import Vue from 'vue'
import App from './views/App.vue'

import router from '@/router'

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
